import { css } from "styled-components";
import { FontMixin } from "../../../../../../styles/common/mixins/helpers.styled.js";
const veciCounterStyles = {
    Label: ()=>css`
		${FontMixin({
            size: 'base'
        })};
		line-height: 22px;
		color: ${({ theme  })=>theme.colors.text.dark};
	`
};
export default veciCounterStyles;

//# sourceMappingURL=veci.js.map